import React, { FunctionComponent } from 'react';
import styled from 'styled-components';
import { Button, ButtonGroup, Column, Columns, Copy, Section } from '@belong/ui-components';
import { withBasePath } from '@belong/url-utils';
import { ISection } from '@belong/ui-components/components/styles/Section';
import { ISupportCategory } from '@belong/types';
import { applyDictionaryToString } from '@belong/contentful';
import ArticleLinkGroup, { IArticleLinkGroup } from './ArticleLinkGroup';

export const TEST_ID = {
  SECTION: 'section-article-groups',
  PARENT_CTA: 'parent-category-link'
};

export interface ISectionArticleGroups extends ISection {
  articles: IArticleLinkGroup[];
  showGroupTitles: boolean;
  parentCategory: ISupportCategory;
  parentCategoryLinkLabel: string;
}

const SectionWrapper = styled(Section)`
  &.link-group-enter .switchable {
    opacity: 0;
  }
  &.link-group-enter-active .switchable {
    opacity: 1;
    transition: opacity 200ms ease-out;
  }
  &.link-group-exit .switchable {
    opacity: 1;
  }
  &.link-group-exit-active .switchable {
    opacity: 0;
    transition: opacity 200ms ease-in;
  }
`;

const SectionLinkGroups: FunctionComponent<ISectionArticleGroups> = ({
  articles = [],
  showGroupTitles,
  parentCategory,
  parentCategoryLinkLabel,
  ...sectionProps
}) => {
  let parentCategoryLink;

  // Only allow parent category link if this is a sub-category
  if (parentCategory) {
    parentCategoryLink = {
      label: applyDictionaryToString({ category: parentCategory.label.toLowerCase() }, parentCategoryLinkLabel),
      href: withBasePath(parentCategory.path)
    };
  }

  return (
    <SectionWrapper data-testid={TEST_ID.SECTION} {...sectionProps}>
      <Columns alignX="center">
        <Column className="switchable" width={{ md: '5/6', lg: '2/3', xl: '1/2' }}>
          {articles.length ? (
            articles.map(group => {
              const groupProps = { ...group, label: showGroupTitles ? group.label : '' };
              return <ArticleLinkGroup key={group.label} {...groupProps} />;
            })
          ) : (
            <Copy>No articles found</Copy>
          )}

          {parentCategoryLink && (
            <ButtonGroup hasControl={['row', 'center']}>
              <Button data-testid={TEST_ID.PARENT_CTA} href={parentCategoryLink.href} variant="secondary">
                {parentCategoryLink.label}
              </Button>
            </ButtonGroup>
          )}
        </Column>
      </Columns>
    </SectionWrapper>
  );
};

export default SectionLinkGroups;
